import { last } from 'lodash';

import { Bankruptcy } from '@willow/graphql-iso/src/app';
import { assertNever, LoanReportingBankruptcyChapter } from '@willow/types-iso';

export const getActiveBankruptcy = (bankruptcies?: Bankruptcy[] | null): Bankruptcy | undefined => {
  return bankruptcies != null ? last(bankruptcies.filter((bankruptcy) => bankruptcy.completedAt === null)) : undefined;
};

export const formatBankruptcyChapterFilterLabel = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Ch 7';
    case 'CHAPTER_11':
      return 'Ch 11';
    case 'CHAPTER_12':
      return 'Ch 12';
    case 'CHAPTER_13':
      return 'Ch 13';
    case 'NONE':
      return 'None';
    default:
      return assertNever(bankruptcyChapter);
  }
};

export const formatBankruptcyChapterShort = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Ch 7';
    case 'CHAPTER_11':
      return 'Ch 11';
    case 'CHAPTER_12':
      return 'Ch 12';
    case 'CHAPTER_13':
      return 'Ch 13';
    case 'NONE':
      return '';
    default:
      return assertNever(bankruptcyChapter);
  }
};

export const formatBankruptcyChapter = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Chapter 7';
    case 'CHAPTER_11':
      return 'Chapter 11';
    case 'CHAPTER_12':
      return 'Chapter 12';
    case 'CHAPTER_13':
      return 'Chapter 13';
    case 'NONE':
      return '';
    default:
      return assertNever(bankruptcyChapter);
  }
};

export const formatBankruptcyChapterLong = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Chapter 7 Bankruptcy';
    case 'CHAPTER_11':
      return 'Chapter 11 Bankruptcy';
    case 'CHAPTER_12':
      return 'Chapter 12 Bankruptcy';
    case 'CHAPTER_13':
      return 'Chapter 13 Bankruptcy';
    case 'NONE':
      return '';
    default:
      return assertNever(bankruptcyChapter);
  }
};
